/**
 * Copyright 2018 Paronix
 */

jQuery.fn.toggleAttr = function(attr) {
	return this.each(function() {
		if($(this).attr(attr) || $(this).attr(attr) === '') {
			$(this).removeAttr(attr);
		} else {
			$(this).attr(attr, '');
		}
	});
};

jQuery.fn.getCursorPosition = function() {
	var input = this.get(0);
	if (!input) return; // No (input) element found
	if ('selectionStart' in input) {
		// Standard-compliant browsers
		return input.selectionStart;
	} else if (document.selection) {
		// IE
		input.focus();
		var sel = document.selection.createRange();
		var selLen = document.selection.createRange().text.length;
		sel.moveStart('character', -input.value.length);
		return sel.text.length - selLen;
	}
};


/*! Copyright (c) 2010 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Version 1.2.3
 */

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    $.fn.overlaps = function(selector) {
        return this.pushStack(filterOverlaps(this, selector && $(selector)));
    };

    function filterOverlaps(collection1, collection2) {
        var dims1  = getDims(collection1),
            dims2  = !collection2 ? dims1 : getDims(collection2),
            stack  = [],
            index1 = 0,
            index2 = 0,
            length1 = dims1.length,
            length2 = !collection2 ? dims1.length : dims2.length;

        if (!collection2) { collection2 = collection1; }

        for (; index1 < length1; index1++) {
            for (index2 = 0; index2 < length2; index2++) {
                if (collection1[index1] === collection2[index2]) {
                    continue;
                } else if (checkOverlap(dims1[index1], dims2[index2])) {
                    stack.push( (length1 > length2) ?
                        collection1[index1] :
                        collection2[index2]);
                }
            }
        }

        return $.unique(stack);
    }

    function getDims(elems) {
        var dims = [], i = 0, offset, elem;

        while ((elem = elems[i++])) {
            offset = $(elem).offset();
            dims.push([
                offset.top,
                offset.left,
                elem.offsetWidth,
                elem.offsetHeight
            ]);
        }

        return dims;
    }

    function checkOverlap(dims1, dims2) {
        var x1 = dims1[1], y1 = dims1[0],
            w1 = dims1[2], h1 = dims1[3],
            x2 = dims2[1], y2 = dims2[0],
            w2 = dims2[2], h2 = dims2[3];
        return !(y2 + h2 <= y1 || y1 + h1 <= y2 || x2 + w2 <= x1 || x1 + w1 <= x2);
    }

}));
var appMode = null;
var mouseDownPageX = 0;
var mouseDownPageY = 0;
var mouseDownTarget;
var currentPageX = 80;
var currentPageY = 235;
var viewScrollTopStart = 0;
var viewScrollLeftStart = 0;
var wrapScrollTop = 0;
var wrapScrollLeft = 0;
var color = 2;
var downTimeout = null;
var sensitivity = 10;
var delay = 300;
var didSelect = false;
var tm = null;
var nm = null;
var scrollbarWidth = $('#wrap')[0].offsetWidth - $('#wrap')[0].clientWidth;
var dbname = "";
var zoom = 1;

// Object to retrieve unique ID's
var uID = {
	counter:0,
	get:function() {
		var id =  "c"+uID.counter++;
		if($("#"+id).length == 0) {
			return id;
		}
		else {
			return uID.get();
		}
	}
};
function pd(e) {
	e.preventDefault();
}

function eds(e) {
	e.preventDefault();
	e.stopImmediatePropagation();
}

function sip(e) {
	e.stopImmediatePropagation();
}

function now() {
	return new Date().getTime();
}

// Convenience method to get the pageX for both mouse and touch
function px(e, useZoom) {
	return (e.changedTouches ? e.changedTouches[0].pageX : e.pageX) / (useZoom === false ? 1: zoom);
}

// Convenience method to get the pageY for both mouse and touch
function py(e, useZoom) {
	return (e.changedTouches ? e.changedTouches[0].pageY : e.pageY) / (useZoom === false ? 1 : zoom);
}

function movedHorizontally() {
	return Math.abs(mouseDownPageX - currentPageX) > sensitivity;
}

function movedVertically() {
	return Math.abs(mouseDownPageY - currentPageY) > sensitivity;
}

function unFocusAll() {
	$('input,textarea').blur();
}

function selectAll() {
	$('#view .selected').removeClass('selected');
	$('#view [s]').removeAttr('s');
	$('#view ta, #view nt').attr('s', '');
	selectionChanged();
}

function deselectAll() {
	$('.selected').removeClass('selected');
	$('circle.s').removeClass('s');
	$('#view [s]').removeAttr('s');
	$('#view [sfk]').removeAttr('sfk');
	selectionChanged();
}

function togglePK(column) {
	column.toggleAttr('p');
}

function toggleUnique(column) {
	if(column.is('[u]')) {
		column.removeAttr('u').attr('uu', '');
	} else if (column.is('[uu]')) {
		column.removeAttr('uu');
	} else {
		column.attr('u', '');
	}
}

function toggleNullable(column) {
	column.toggleAttr('n');
}

function toggleOnDelete(column) {
	if(!column.is('[fk]'))
		return;

	if(column.is('[dc]')) {
		column.removeAttr('dc').attr('dr', '');
	} else if (column.is('[dr]')) {
		column.removeAttr('dr').attr('dn', '');
	} else if (column.is('[dn]')) {
		column.removeAttr('dn');
	} else {
		column.attr('dc', '');
	}
}

function setCursorPosition(input, pos, len) {
	input.focus();

	if(typeof len === "undefined") {
		len = 0;
	}

	var el = input[0];
	if (el.setSelectionRange) {
		el.setSelectionRange(pos, pos+len);
	}
	else if (el.createTextRange) {
		var range = el.createTextRange();
		range.collapse(true);
		range.moveEnd('character', pos+len);
		range.moveStart('character', pos);
		range.select();
	}
}

function toggleOnUpdate(column) {
	if(!column.is('[fk]'))
		return;

	if(column.is('[uc]')) {
		column.removeAttr('uc').attr('ur', '');
	} else if (column.is('[ur]')) {
		column.removeAttr('ur');
	} else {
		column.attr('uc', '');
	}
}

function checkSize(input) {
	var val = input.val();
	if(val == "") {
		val = input.attr("placeholder") || "";
	}
	tm.html(val.replace(/&/g, '&amp;').replace(/\s/g, '&nbsp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
	input.width(Math.max(5, Math.round(tm.outerWidth()+5)));
}

function getNoteSize(textarea) {
	var val = textarea.val();
	nm.width(textarea.width());
	nm.height(16);
	nm.val(val);
	nm.height(nm[0].scrollHeight);
	return {
		'width': Math.max(50, nm.width()) + 22,
		'height': Math.max(20, nm[0].scrollHeight) + 32
	};
}

function removeColumn(column, skipFocus) {
	if(column.is('c') && column.closest('ta').find('c').length > 1) {

		if(skipFocus !== true) {
			// Focus on the next or previous element, depending on availability.
			var focusElem = (column.next('c').length ? column.next('c') : column.prev('c'));
			focusOnColumn(focusElem, 0, 0);
		}
		$(column).remove();
		cleanUpOrphanedForeignKeyReferences();
	}

	redraw();
}

if(typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function(suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

// Determine the value that the input must have based on the separate elements within the <c> element
function getColumnTextBasedOnElements(columnElement) {
	var text = "";
	columnElement.find('e,n,t,s,d').each(function(index, el) {
		text += ((text == "" || $(el).is("s") ? "" : " ") + $(this).text());
	});

	return text;
}

function getAllColumnNamesPrefixedByTablename(currentColumn) {
	var columnNames = [];
	$('#view ta').each(function(index, el) {
    	var tableName = pluralize.singular($(this).find('h input').val());
    	$(this).find('c').each(function(index, el) {
    		if(typeof currentColumn === 'undefined' || !$(this).is(currentColumn) && ($(this).find('n').text() != "")) {
    			var colName = $(this).find('n').text();
    			var tableColName = tableName + "_" + colName;
    			if($.inArray(colName, columnNames) == -1) columnNames.push(colName);
    			if($.inArray(tableColName, columnNames) == -1) columnNames.push(tableColName);
    		}
    	});
    });
    return columnNames;
}

var pgRegexes = [
	// Only name
	[/^([a-zA-Z_][a-zA-Z0-9_]*)$/, "<n>$1</n>"],

	// Name and space
	[/^([a-zA-Z_][a-zA-Z0-9_]*) $/, "<n>$1</n><t></t>"],

	// Name and type
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (bigint|bigserial|bit|bool|boolean|box|bytea|char|cidr|circle|date|decimal|int4range|int8range|numrange|tsrange|tstzrange|daterange|float4|float8|inet|int|int2|int4|int8|integer|interval|json|jsonb|line|lseg|macaddr|money|numeric|path|pg_lsn|point|polygon|real|serial|serial2|serial4|serial8|smallint|smallserial|text|time|timetz|timestamp|timestamptz|tsquery|tsvector|txid_snapshot|uuid|varbit|varchar|xml)?$/, "<n>$1</n><t>$2</t>"],

	// Name, sizeable type and (
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (bit|varbit|char|varchar|interval|decimal|numeric|time|timetz|timestamp|timestamptz)\($/, "<n>$1</n><t>$2(</><s></s>"],

	// Name, type and size specified as (p,s)
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (numeric|decimal)(\([0-9]+, ?[0-9]+\))$/,"<n>$1</n><t>$2</t><s>$3</s>"],

	// Name, sizeable type, size specified as (p,s) and space
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (numeric|decimal)(\([0-9]+, ?[0-9]+\)) $/,"<n>$1</n><t>$2</t><s>$3</s><d></d>"],

	// Name, sizeable type and size as single integer
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (bit|varbit|numeric|decimal|char|varchar)(\([0-9]+\))$/, "<n>$1</n><t>$2</t><s>$3</s>"],

	// Name, sizeable type, size as single integer and space
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (bit|varbitnumeric|decimal|char|varchar)(\([0-9]+\)) $/, "<n>$1</n><t>$2</t><s>$3</s><d></d>"],

	// Name, sizeable type, size as single integer and default
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (bit|varbitnumeric|decimal|char|varchar)(\([0-9]+\)) (.*)$/, "<n>$1</n><t>$2</t><s>$3</s><d>$4</d>"],

	// Name, sizeable type and default
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (bit|varbitnumeric|decimal|char|varchar) (.*)$/, "<n>$1</n><t>$2</t><d>$3</d>"],

	// Name, time type and precision size
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (time|timetz|timestamp|timestamptz)(\([0-6]\))$/, "<n>$1</n><t>$2</t><s>$3</s>"],

	// Name, time type, precision size and space
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (time|timetz|timestamp|timestamptz)(\([0-6]\)) $/, "<n>$1</n><t>$2</t><s>$3</s><d></d>"],

	// Name, time type, precision size and default value
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (time|timetz|timestamp|timestamptz)(\([0-6]\)) (.*)+$/, "<n>$1</n><t>$2</t><s>$3</s><d>$4</d>"],

	// Name, time type and default value (no precision)
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (time|timetz|timestamp|timestamptz) (.*)$/, "<n>$1</n><t>$2</t><d>$3</d>"],

	// Name, unsizeable type and a default value
	[/^([a-zA-Z_][a-zA-Z0-9_]*) (bigint|boolean|box|bytea|cidr|circle|date|int4range|int8range|numrange|tsrange|tstzrange|daterange|float4|float8|smallint|inet|int|int2|int4|int8|integer|json|jsonb|line|lseg|macaddr|money|path|point|polygon|real|text|tsquery|tsvector|txid_snapshot|uuid|xml) (.*)+$/, "<n>$1</n><t>$2</t><d>$3</d>"]

	// TODO match interval type. (later)
];

function getColumnElementsFromText(text) {

	// If the text is empty simply return an empty <n> element (required for the primary key toggle)
	if(text == "") {
		return "<n></n>";
	}

	// Loop through possible matches and if it matches, use the replacement that goes with the match
	for(var i = 0; i < pgRegexes.length; i++) {
		if(text.match(pgRegexes[i][0])) {
			return text.replace(pgRegexes[i][0], pgRegexes[i][1]);
		}
	}

	// If we end up here, we don't have valid stuff so match the name and error out the rest
	if(text.match(/^([a-zA-Z_][a-zA-Z0-9_]*)( .*)$/)) {
		return text.replace(/^([a-zA-Z_][a-zA-Z0-9_]*)( .*)$/, "<n>$1</n><e>$2</e>");
	}

	return '<n class="error">' + text + '</n>';
}

function addNewColumnBelow(column) {
	var newColumn = $("<c><n></n><ca></ca></c>");
	newColumn.attr('id', uID.get());
	newColumn.insertAfter(column);
	unFocusAll();
	focusOnColumn(newColumn);
	redraw();
}

function addTable(atMousePosition) {
	var newTable = $('<ta><h><input value="" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"></h><c><n></n><ca></ca></c></ta>');

	newTable.find('h').attr("c", ""+color);
	newTable.find('c').attr("id", uID.get());

	$('#view').append(newTable);

	viewScrollLeftStart = $('#wrap').scrollLeft();
	viewScrollTopStart = $('#wrap').scrollTop();

	if(atMousePosition === true) {
		newTable.css({
			'top': (viewScrollTopStart + currentPageY) + "px",
			'left': (viewScrollLeftStart + currentPageX) + "px"
		});
	} else {
		newTable.css({
			'top': (viewScrollTopStart + 235) + "px",
			'left': (viewScrollLeftStart + 80) + "px"
		});
	}

	drawMinimap();

	focusOnHead(newTable.find('h'));
	checkSize(newTable.find('h input'));

	return newTable;
}

function addNote(atMousePosition) {
	var newNote = $('<nt style="width:200px;height:48px;"><textarea></textarea></nt>');

	$('#view').append(newNote);

	viewScrollLeftStart = $('#wrap').scrollLeft();
	viewScrollTopStart = $('#wrap').scrollTop();

	if(atMousePosition === true) {
		newNote.css({
			'top': (viewScrollTopStart + currentPageY) + "px",
			'left': (viewScrollLeftStart + currentPageX) + "px"
		});
	} else {
		newNote.css({
			'top': (viewScrollTopStart + 235) + "px",
			'left': (viewScrollLeftStart + 80) + "px"
		});
	}

	drawMinimap();
	newNote.find('textarea').focus();
}

function removeTable(table) {
	table.remove();
	cleanUpOrphanedForeignKeyReferences();
}

function cleanUpOrphanedForeignKeyReferences() {
	var changed = false;
	$('#view c[fk]').each(function(index, el) {
		if($('#' + $(this).attr('fk')).length == 0) {
			$(this).removeAttr('fk');
			changed = true;
		}
	});

	if(changed) {
		redraw();
	}
}

function setTableColor(table) {
	table.find('h').attr('c', ''+color);
	// Also set the same color on selected tables.
	if(table.is('[s]')) {
		$('#view ta[s] h').attr('c', ''+color);
	}
	redraw();
}

function deleteSelectedElements() {
	$('#view [s]').each(function(index, el) {
		var elem = $(this);
		if(elem.is('ta')) {
			removeTable(elem);
		} else if (elem.is('c')) {
			removeColumn(elem, true);
		} else if (elem.is('nt')) {
			elem.remove();
		}
	});

	$('#svgwrap .selected').each(function(index, el) {
		$('#'+$(this).attr('data-cid')).removeAttr('fk');
	});

	$('#view [sfk]').each(function(index, el) {
		$(this).removeAttr('sfk');
	});

	redraw();
	selectionChanged();
}

function selectionChanged() {
	$(document).trigger('selectionChanged');
}

function createColumnElementsFromHiddenInput(input) {
	// Remove all existing elements and add the newly created elements
	input.closest('c').find('n,t,s,d,e').remove();
	input.closest('c').prepend(getColumnElementsFromText(input.val()));
}

function insertSuggestion(input) {
	var chosen = $('#suggestions li.active').text();
	var value = input.val();
	var cursorPosition = input.getCursorPosition();
	var valueUpToCursor = value.substring(0, cursorPosition);
	var spaceCount = (valueUpToCursor.split(/[ \(]{1}/).length - 1);
	var cursorWord = value.split(/[ \(]{1}/)[spaceCount];

	if(spaceCount == 1 && /^(bit|varbit|numeric|decimal|char|varchar)$/.test(chosen) && value.indexOf('(') == -1) {
		chosen += "(";
	}

	var newValue = value.replace(
		spaceCount == 0 ? /^([^ ]+)(.*)$/ : /^([^ ]+ )([^ \(]+)(.*)$/,
		spaceCount == 0 ? chosen + '$2' : '$1' + chosen + '$3'
	) + (spaceCount == 0 ? ' ' : '');

	input.val(newValue);
	createColumnElementsFromHiddenInput(input);
	setCursorPosition(input, newValue.length, 0);
	$('#suggestions').empty();
}

$(function() {
	$('#suggestions').on('mousedown', 'li', function(event) {
		eds(event);
		$('#suggestions li').removeClass('active');
		$(this).addClass('active');
		insertSuggestion($('input:focus'));
	});
});

function createCrossTable(fromColumn, toColumn) {
	var id1 = uID.get();
	var id2 = uID.get();
	var fromTable = fromColumn.closest('ta');
	var toTable = toColumn.closest('ta');
	var fromName = fromTable.find('h input').val();
	var toName = toTable.find('h input').val().split('.').pop();
	var color = fromTable.find('h').attr('c');
	// TODO refactor to using addTable instead
	var crossTable = $('<ta><h c="' + color + '"><input value="' + fromName + "_" + toName + '" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"></h><c id="' + id1 + '" p><n></n><ca></ca></c><c id="' + id2 + '" p><n></n><ca></ca></c></ta>');
	$('#view').append(crossTable);
	$('#'+id1).attr('fk', fromColumn.attr('id')).html(fromColumn.html());
	$('#'+id2).attr('fk', toColumn.attr('id')).html(toColumn.html());
	var fromTableName = pluralize.singular($.trim(fromTable.find('h input').val().split('.').pop()));
	var toTableName = pluralize.singular($.trim(toTable.find('h input').val().split('.').pop()));
	$('#'+id1).find('n').text(fromTableName + "_" + fromColumn.find('n').text());
	$('#'+id2).find('n').text(toTableName + "_" + toColumn.find('n').text());
	checkSize(crossTable.find('h input'));

	crossTable.css({
		'top': (fromTable.position().top + 15) + "px",
		'left': (fromTable.position().left + fromTable.outerWidth() + 100) + "px",
	});
}

function saveDb() {
	// Copy the values over to the actual "value" attribute, otherwise jquery's html() function will not return it.
	$("#view input").each(function(){
		$(this).attr("value", $(this).val());
	});
	// Copy the textarea (notes) values over to the html() of the textarea, otherwise jquery's html() function will not return it.
	$("#view textarea").each(function(){
		$(this).html($(this).val());
	});
	var content = $('#view').html();
	var newName = prompt("Name to save as", dbname);

	if(newName != null) {
		var r = confirm("Are you sure you want to save as '" + newName + "'?");
		if(r == true) {
			dbname = newName;
			$.post("http://test.dbquickly.com/save.php", {
				'name': newName,
				'content': content
			}, function(data) {
				alert("saved");
			}).fail(function(e) {
				alert("error saving");
				console.log(e);
			});
		}
	}
}

function openDb() {
	var loadName = prompt("Name to load", dbname);

	if(loadName != null) {
		var r = confirm("Are you sure you want to load '" + loadName + "'?");
		if(r == true) {
			dbname = loadName;
			$.get("http://test.dbquickly.com/load.php?name=" + loadName, function(data) {
				$('#view').empty();
				$('#view').html(data);
				cleanUpOrphanedForeignKeyReferences();
				redraw();
				$(document).trigger('contentChanged');
			}).fail(function(e) {
				alert("error loading");
				console.log(e);
			});
		}
	}
}

function getFontMultiplier() {
	return 7.19 * zoom;
}

function setWrapSize() {
	$('#wrap').css({
		'transform': 'scale(' + zoom + ')',
		'transform-origin': 'top left',
		'width': $(window).width() / zoom + "px",
		'height': $(window).height() / zoom + "px",
	});
}
function redraw() {
	if($('#minimap').is(':visible')) {
		drawMinimap();
	}
	drawConnectors();
}

function drawMinimap() {

	var mm = $('#minimap');
	var mw = mm.outerWidth();
	var mh = mm.outerHeight();
	var vw = $('#view').width();
	var vh = $('#view').height();
	var sx = mw / vw;
	var sy = mh / vh;

	mm.empty();

	var minimapElements = [];

	$('#view ta, #view nt').each(function(index, el) {
		var ta = $(el);
		var t = (ta.position().top / zoom) * sy;
		var l = (ta.position().left / zoom) * sx;
		var w = ta.outerWidth() * sx;
		var h = ta.outerHeight() * sy;
		var e = $('<div>');
		e.css({
			'top': t,
			'left': l,
			'width': w,
			'height': h
		}).attr('c', ta.find('h').attr('c') || 'n');
		minimapElements.push(e);
	});

	var wr = $('#wrap');
	var t = wr.scrollTop() * sy;
	var l = wr.scrollLeft() * sx;
	var w = wr.outerWidth() * sx;
	var h = wr.outerHeight() * sy;
	var e = $('<div>');
	e.css({
		'top': t-1,
		'left': l-1,
		'width': w,
		'height': h
	}).attr('id', 'md');
	minimapElements.push(e);

	// append is an expensive operation. providing it with an array of elements is much faster then calling append() seperately for each element.
	mm.empty().append(minimapElements);
}

function drawConnectors(id1, id2) {

	// Remove everything in the FKS svg element
	$('#fks').empty();

	wrapScrollLeft = $('#wrap').scrollLeft() * zoom;
	wrapScrollTop =  $('#wrap').scrollTop() * zoom;

	var elementsToDraw = [];

	// Loop through all TR's having a fk attribute and draw the connector for it.
	$('#view c[fk]').each(function(index, el) {
		elementsToDraw= elementsToDraw.concat(drawConnector($(this).attr('id'), $(this).attr('fk'), $(this).is('c[sfk]')));
	});

	if(typeof id1 !== "undefined" && typeof id2 !== "undefined") {
		elementsToDraw= elementsToDraw.concat(drawConnector(id1, id2, true));
	}

	$('#fks').append($(elementsToDraw.join('')));

	// Workaround that reinitializes the SVG to make sure it draws elements being added using jQuery.
	$('#svgwrap').html($('#svgwrap').html());
}

function drawConnector(id1, id2, selected) {

	var margin = 30;

	var e1 = $('#' + id1);
	var o1 = e1.offset();
	o1.left += wrapScrollLeft;
	o1.top += wrapScrollTop - 50;

	o1.left = o1.left / zoom;
	o1.top = o1.top / zoom;

	var e2 = $('#' + id2);
	var o2 = e2.offset();
	o2.left += wrapScrollLeft;
	o2.top += wrapScrollTop - 50;

	o2.left = o2.left / zoom;
	o2.top = o2.top / zoom;

	var x1 = o1.left;
	var w1 = e1.outerWidth();
	var y1 = o1.top + (e1.outerHeight()/2);
	var fx1 = x1;

	var x2 = o2.left;
	var w2 = e2.outerWidth();
	var y2 = o2.top + (e2.outerHeight()/2);
	var fx2 = x2;
	var t = "M";

	if(x1+w1+margin < x2) {
		fx1 += w1;
	}

	if(x2+w2+margin < x1) {
		fx2 += w2;
		t += (fx2+5) + "," + y2 + "," + (fx2+15) + "," + (y2-5) + "," + (fx2+15) + "," + (y2+5) + "," + (fx2+5) + "," + y2;
	} else {
		t += (fx2-5) + "," + y2 + "," + (fx2-15) + "," + (y2-5) + "," + (fx2-15) + "," + (y2+5) + "," + (fx2-5) + "," + y2;
	}

	var mx = Math.abs((fx2-15-fx1) * 0.5);

	if(fx2 > fx1 && fx1 != x1) {
		cpx1 = fx1 + mx;
		cpx2 = fx2 - mx;
	}
	else if(fx2 < fx1 && fx2 != x2) {
		cpx1 = fx1 - mx;
		cpx2 = fx2 + mx;
	}
	else {
		cpx1 = fx1 - mx - 80;
		cpx2 = fx2 - mx - 80;
	}

	if(fx2 != x2) {
		fx2 += 15;
		cpx2 += 15;
	} else {
		fx2 -= 15;
		cpx2 -= 15;
	}

	var colorClass = "c0";

	if(id2.charAt(0) == "c") {
		colorClass = "c" + e2.closest('ta').find('h').attr('c');
	}

	// Define the path for the line
	var p = "M" + fx1 + "," + y1 + " C" + cpx1 +","+y1+" "+cpx2+","+y2+" "+fx2+","+y2;

	return [
		// The arrow head
		'<path class="a ' + colorClass + (selected === true ? ' selected':'') + '" d="' + t + '"></path>',
		// this is the path we select with. it's invisible but thick
		'<path id="p' + id1 + '" class="s" d="' + p + '"></path>',
		// This is the visible path.
		'<path d="' + p + '" data-cid="' + id1 + '" class="' + colorClass + (selected === true ? ' selected' : '') + '"></path>'
	];
}
$(function() {

	var cancelCheck = function(e) {


		// If the target is an input or a textarea with focus then stop to allow selection of text
		if($(e.target).is('input') || $(e.target).is('textarea:focus')) {
			return true;
		}

		return false;
	};

	$('#wrap').on({
		'mousedown touchstart': function(e) {

			if(cancelCheck(e)) {
				return;
			}

			if(e.type == 'mousedown' && e.which !== 1) {
			 	return;
			}

			eds(e);
			unFocusAll();

			// Set the appMode to an emtpy string. This indicates that something is about to happen but it's not certain what exactly. This is determined by the target and the movement the user makes on the target. (see mousemove touchmove)
			appMode = "";

			// Save the target, down and scroll positions when the mouse went down or touch started. This is needed later for moving and determining the appMode
			mouseDownTarget = e.target;
			mouseDownPageX = currentPageX = px(e);
			mouseDownPageY = currentPageY = py(e);
			viewScrollLeftStart = $('#wrap').scrollLeft();
			viewScrollTopStart = $('#wrap').scrollTop();

			// mousedown in the lower corner of a note (nt element)? Then it means to resize it.
			if($(e.target).is('nt')) {
				var elem = $(e.target);
				var cx = (elem.offset().left / zoom) + elem.outerWidth();
				var cy = (elem.offset().top/ zoom) + elem.outerHeight();
				if(cx - px(e) < 30 && cy - px(e) < 30) {
					appMode = "resizeNote";
					return;
				}
			}

			// If the mouse is down on the view (or actually the svg that holds the connectors) simply set the appMode to view. No further movement checking is necessary.
			if(mouseDownTarget == $('#fks')[0]) {
				appMode = "view";

				if(e.ctrlKey || e.altKey) {
					appMode = "selector";
					$('#selector').data({
						'xpos': px(e,false),
						'ypos': py(e,false)
					});
				}

				return;
			}

			// If the target is within a table head, set the mouseDownTarget to the table and appMode to preTable as we do not known if we are moving the table or not.
			if($(mouseDownTarget).closest('h').length) {
				mouseDownTarget = $(mouseDownTarget).closest('ta').first();
				var t = mouseDownTarget;

				mouseDownTarget.add('#view ta[s], #view nt[s]').each(function(index, el) {
					var t = $(el);
					t.data({
						'xpos': t.offset().left + t.outerWidth() - px(e,false),
						'ypos': t.offset().top + t.outerHeight() - py(e,false)
					});
				});
				appMode = "preTable";
			}
			// If the target is within a column then set the mouseDownTarget to the column and the appMode to preColumn as we do not known if we are moving a column or starting a FK mode.
			else if($(mouseDownTarget).closest('c').length) {
				mouseDownTarget = $(mouseDownTarget).closest('c');
				appMode = "preColumn";
			}

			if($(mouseDownTarget).is('textarea,nt')) {
				mouseDownTarget = $(mouseDownTarget).closest('nt');
				mouseDownTarget.add('#view ta[s], #view nt[s]').each(function(index, el) {
					var t = $(el);
					t.data('xpos', t.offset().left + t.outerWidth() - px(e,false));
					t.data('ypos', t.offset().top + t.outerHeight() - py(e,false));
				});
				appMode = "preNote";
			}

			// If the target is a path.s (the invisible thicker path that is used to select paths with) then return for now as there is nothing to be done during the mousedown phase
			else if($(mouseDownTarget).is('path.s')) {
				return;
			}

			// If it's not a path.s then set a timeout to check if the user was holding something down (selecting columns or tables on touch devices for instance)
			downTimeout = setTimeout(function() {
				downTimeout = null;
				if(!movedHorizontally() && !movedVertically()) {
					if(appMode === "preTable" || appMode === "preNote") {
						mouseDownTarget.toggleAttr('s');
						didSelect = true;
					} else if (appMode === "preColumn") {
						mouseDownTarget.closest('c').toggleAttr('s');
						didSelect = true;
					}
				}
			}, delay);
		},
		'mouseup touchend': function(e) {
			if(cancelCheck(e)) {
				return;
			}

			eds(e);

			// Remove a possible timeout if the user stopped pressing the mouse down or touching the screen.
			if(downTimeout != null) {
				clearTimeout(downTimeout);
				downTimeout = null;
			}

			// If the appMode was preTable it means the table did not move yet but the thead was clicked/tapped so focus on the table name.
			if(appMode === "preTable" && !didSelect) {
				focusOnHead(mouseDownTarget, px(e) - mouseDownTarget.offset().left);
			}

			// If the appMode is precolumn it means the user did not reorder or started FK mode so focus on an input or toggle a PK, UNQ or NULL
			if(appMode === "preColumn" && !didSelect) {
				var fromLeft = px(e, false) - mouseDownTarget.offset().left;
				var fromRight = (mouseDownTarget.offset().left + (mouseDownTarget.outerWidth() * zoom) - px(e, false)) / zoom;

				if(fromLeft > 30 && fromRight > 120) {
					focusOnColumn(mouseDownTarget, (fromLeft - 35) / zoom);
				}
				else if(fromLeft < 30) {
					togglePK(mouseDownTarget);
				} else if(fromRight > 0 && fromRight < 30) {
					toggleOnUpdate(mouseDownTarget);
				} else if(fromRight > 30 && fromRight < 60) {
					toggleOnDelete(mouseDownTarget);
				} else if(fromRight > 60 && fromRight < 90) {
					toggleNullable(mouseDownTarget);
				} else if(fromRight > 90 && fromRight < 120) {
					toggleUnique(mouseDownTarget);
				}
			}

			// If the appMode was preTable it means the table did not move yet but the thead was clicked/tapped so focus on the table name.
			if(appMode === "preNote" && !didSelect) {
				$(mouseDownTarget).find('textarea').focus();
			}

			if(appMode === "resizeNote") {
				var noteSize = getNoteSize($(mouseDownTarget).find('textarea'));
				$(mouseDownTarget).css({'width': noteSize.width+'px', 'height': noteSize.height+'px'});
			}

			if(appMode === "selector") {
				if(e.ctrlKey) {
					$('#view ta, #view nt').css({'outline': '', 'outline-offset': ''}).overlaps('#selector').attr('s', '');
				} else if(e.altKey) {
					$('#view ta, #view nt').css({'outline': '', 'outline-offset': ''}).overlaps('#selector').removeAttr('s');
				}
				$('#selector').hide();
			}

			// If the appMode is "order" it means we stopped dragging a column around so remove the ghost element (#gh) and clear the manually set styles by removing the style attribute.
			if(appMode === "order") {
				mouseDownTarget.closest('c').removeAttr('style');
				$('#gh').remove();
			}

			// If the mode is FK (connecting a foreign key) then get the current element under the mouse and set up a FK connection.
			if(appMode === "fk") {

				var targetUnderMouse = $(document.elementFromPoint(px(e, false), py(e, false)));

				// check if we're connecting to a column
				if(targetUnderMouse.closest('c').length) {

					var toColumn = targetUnderMouse.closest('c');
					var fromColumn = $(mouseDownTarget).closest('c');

					// Make sure we are not trying to connect to the same column or a column of a different type.
					if(fromColumn != toColumn && (fromColumn.find('t').text() == "" || fromColumn.find('t').text() == toColumn.find('t').text())) {

						// If we are connecting the first columns of both tables and both have the primary key attribute and the user is pressing the alt key
						// then create a cross-table and set up two FK's in the cross-table for a many to many relationship.
						if(event.altKey && fromColumn.prev().is('h') && toColumn.prev().is('h') && fromColumn.is('[p]') && toColumn.is('[p]')) {
							createCrossTable(fromColumn, toColumn);
						} else {
							fromColumn.attr('fk', toColumn.attr('id'));

							// Connecting a type-less column so autoinsert name and type.
							if(fromColumn.find('t').text() == "") {
								fromColumn.html(toColumn.html());
								var tableName = pluralize.singular($.trim(toColumn.closest('ta').find('h input').val().split('.').pop()));
								fromColumn.find('n').text(tableName + "_" + fromColumn.find('n').text());
							}
						}
					}
				}
			}

			// If the target is a path.s (thicker path to select FK connectors) then toggle the path to be selected or not.
			if($(mouseDownTarget).is('path.s')) {
				var con = $(mouseDownTarget);
				var cid = con.attr('id').substr(1);
				if($('#'+cid + '[sfk]').length == 0) {
					$('#'+cid).attr('sfk', '');
				} else {
					$('#'+cid).removeAttr('sfk');
				}
				didSelect = true;
			}

			if($(mouseDownTarget).is('#fks')) {
				unFocusAll();
			}

			// the appMode is not null, something may have changed so redraw.
			if(appMode !== null) {
				redraw();
			}

			// Set the appMode to null
			appMode = null;

			if(didSelect) {
				selectionChanged();
			}

			// Reset didSelect
			didSelect = false;
		},
		'mousemove touchmove': function(e) {

			// Store the current mouse/touch coordinates
			currentPageX = px(e);
			currentPageY = py(e);

			if(cancelCheck(e)) {
				return;
			}

			if(e.type == "mousemove") {
				if (!(e.buttons & 1) && !(e.buttons === undefined && e.which == 1)) {
					appMode = null;
					return;
				}
			}

			// If appMode is null it means the mouse is up or no touch is taking place so we don't have to check for anything
			if(appMode === null) return;

			// If the appMode is view then simply scroll the view with the users movement.
			if(appMode === "view") {
				$('#wrap').scrollLeft(viewScrollLeftStart + (mouseDownPageX - px(e)));
				$('#wrap').scrollTop(viewScrollTopStart + (mouseDownPageY - py(e)));
				return;
			}

			if(appMode === "selector") {
				var startX = $('#selector').data('xpos');
				var startY = $('#selector').data('ypos');
				var width = px(e, false) - $('#selector').data('xpos');
				var height = py(e, false) - $('#selector').data('ypos');
				$('#selector').show().css({
					'left': viewScrollLeftStart + (width >= 0 ? startX : startX + width) + "px",
					'top': viewScrollTopStart - 50 + (height >= 0 ? startY : startY + height) + "px",
					'width': Math.abs(width) + "px",
					'height': Math.abs(height) + "px"
				});

				$('#view ta, #view nt').css({'outline': '', 'outline-offset': ''}).overlaps('#selector').css({'outline': '2px dashed #0ab', 'outline-offset': '5px'});

			}

			// If the appMode is preTable and the user moved enough, set it to "table" so that the user can move the table around.
			if(appMode === "preTable" && (movedHorizontally() || movedVertically())) {
				if(didSelect) mouseDownTarget.toggleAttr('s');
				appMode = "table";
			}

			// If the appMode is preNote and the user moved enough, set it to "moveNote" so that the user can move the note around.
			if(appMode === "preNote" && (movedHorizontally() || movedVertically())) {
				if(didSelect) mouseDownTarget.toggleAttr('s');
				appMode = "moveNote";
			}

			// If we are in preColumn mode and we only moved horizontally, start fk mode
			if(appMode === "preColumn" && movedHorizontally() && !movedVertically()) {
				appMode = "fk";
			}

			// If the appMode is preColumn and the user moved only vertically then start ordering mode
			if(appMode === "preColumn" && !movedHorizontally() && movedVertically()) {
				appMode = "order";
				mouseDownTarget = mouseDownTarget.closest('c');

				// If a column was selected prior to reordering (because the user held the column just a little too long before moving it to re-order) then toggle the selection back.
				if(didSelect) mouseDownTarget.toggleAttr('s');

				// Make a clone of the column and give it and id of "gh"
				var clone = mouseDownTarget.clone();
				clone.attr('id', 'gh');
				// The clone should have some proper styling and it should be made as wide as the <ta> element it is in. Also remove an FK attribute otherwise a connector would be drawn to the clone.
				clone.css({
					'position': 'absolute',
					'background': '#f5f5f5',
					'left': '0px',
					'right': '0px'
				}).removeAttr('fk');
				// Append the clone to the <ta> element.
				mouseDownTarget.closest('ta').append(clone);

				// Make the actual column invisible by setting it's opacity to 0
				mouseDownTarget.css('opacity', 0);
			}

			if(appMode === "resizeNote") {
				var newWidth = Math.max(72, px(e, false) - $(mouseDownTarget).offset().left + 5) / zoom;
				var newHeight = Math.max(50, py(e, false) - $(mouseDownTarget).offset().top + 5) / zoom;
				var noteSize = getNoteSize($(mouseDownTarget).find('textarea'));
				$(mouseDownTarget).css({'width': newWidth + "px", 'height': Math.max(newHeight, noteSize.height) + "px"});
			}

			// If we are in ForeignKey mode,
			if(appMode === 'fk') {
				// Make sure the "fkhover" (invisible div) element is underneath the mouse so we can draw a faux connector to it in case the user does not hover on a connectable column.
				$('#fkhover').css({'top': py(e) + viewScrollTopStart - 50, 'left': px(e) + viewScrollLeftStart});

				// Get the ID and datatype of the column that we are connecting from
				var fkid = $(mouseDownTarget).closest('c').attr('id');
				var fktype = $(mouseDownTarget).closest('c').find('t').text();

				// Get the element underneath the cursor.
				var elem = $(document.elementFromPoint(px(e,false), py(e,false))).closest('c');

				// If that element is within a <c> element (column) then continue checking.
				if(elem.length) {
					// If the user is not hovering the same column (can't connect to yourself) and the datatypes match, then allow the connection.
					if(fkid != elem.attr('id') && (elem.find('t').text() == fktype || fktype == "")) {
						drawConnectors(fkid, elem.closest('c').attr('id'));
					}
					// The element is the same column or a column without a matching data type so draw a connector to the current mouse position using the "fkhover" element
					else {
						drawConnectors(fkid, 'fkhover');
					}
				}
				// The element being hovered over is not a column so draw a connector to the current mouse position using the "fkhover" element
				else {
					drawConnectors(fkid, 'fkhover');
				}
				return;
			}

			// If the appMode is table, it means the user is moving a table so reposition the table and all selected tables.
			if(appMode == "table" || appMode == "moveNote") {
				mouseDownTarget.add('#view ta[s], #view nt[s]').each(function(index, el) {
					var t = $(el);
					var max_left = t.parent().offset().left + t.parent().width() - t.width();
					var max_top = t.parent().offset().top + t.parent().height() - t.height();
					var min_left = t.parent().offset().left;
					var min_top = t.parent().offset().top;

					var itop = py(e, false) + t.data('ypos') - t.outerHeight();
					var ileft = px(e, false) + t.data('xpos') - t.outerWidth();

					if(itop <= min_top ) { itop = min_top; }
					if(ileft <= min_left ) { ileft = min_left; }
					if(itop >= max_top ) { itop = max_top; }
					if(ileft >= max_left ) { ileft = max_left; }

					// itop = 10 * Math.round(itop / 10);
					// ileft= 10 * Math.round(ileft / 10);

					t.offset({ top: itop, left: ileft});
				});
			}

			// If the appMode is order then reposition the ghost element (id 'gh') for visual feedback.
			if(appMode === 'order') {
				// Calculate the bounds that the user is allowed to drag the column within.
				var table = mouseDownTarget.closest('ta');
				var tableTop = table.offset().top / zoom;
				var min = tableTop + mouseDownTarget.outerHeight();
				var max = tableTop + table.outerHeight() - mouseDownTarget.outerHeight();
				var y = py(e) - (mouseDownTarget.outerHeight()/2);
				// and keep it within those calculated bounds.
				if(y < min) y = min;
				if(y > max) y = max;
				y -= tableTop;
				$('#gh').css('top', y + 'px');

				// Calculate the index the column should now have within it's <ta> element and use the correct insertBefore or insertAfter methods to put the column where it should be.
				var index = Math.round(y / mouseDownTarget.outerHeight());
				if(index < mouseDownTarget.index()) {
					mouseDownTarget.insertBefore(table.children().eq(index));
				} else {
					mouseDownTarget.insertAfter(table.children().eq(index));
				}
			}

			// Since the appMode is not null (returns at the top of this function) something may have changed that requires a redraw of things so simply redraw.
			// TODO make redraw smarter so that we only redraw the necessary connectors.
			redraw();
		}
	});
});
$(function() {

	$('#minimap').on({
		'mousedown touchstart': function(e) {

			if(e.type == 'mousedown' && e.which !== 1) {
			 	return;
			}

			eds(e);
			unFocusAll();

			// If the mouse went down on the minimap control set the appMode to minimap
			if(e.target == $('#md')[0]) {
				var md = $(e.target);
				md.data('xpos', md.offset().left + md.outerWidth() - px(e, false));
				md.data('ypos', md.offset().top + md.outerHeight() - py(e, false));
				return;
			}
		},
		'mouseup touchend': function(e) {
			eds(e);
		},
		'mousemove touchmove': function(e) {

			if(e.type == "mousemove") {
				if (!(e.buttons & 1) && !(e.buttons === undefined && e.which == 1)) {
					return;
				}
			}

			var mm = $('#minimap');
			var md = $('#md');
			var mw = mm.outerWidth();
			var mh = mm.outerHeight();
			var vw = $('#view').width();
			var vh = $('#view').height();
			var sx = mw / vw;
			var sy = mh / vh;

			var max_left = mm.width() - md.width();
			var max_top = mm.height() - md.height();
			var min_left = 0;
			var min_top = 0;

			var itop = py(e, false) - mm.offset().top + md.data('ypos') - md.outerHeight();
			var ileft = px(e, false) - mm.offset().left + md.data('xpos') - md.outerWidth();

			if(itop <= min_top ) { itop = min_top; }
			if(ileft <= min_left ) { ileft = min_left; }
			if(itop >= max_top ) { itop = max_top; }
			if(ileft >= max_left ) { ileft = max_left; }

			md.css({ top: itop, left: ileft});

			$('#wrap').scrollLeft(ileft / sx);
			$('#wrap').scrollTop(itop / sy);
		}
	});
});
function focusOnColumn(column, x, len) {

	if(typeof len === "undefined") {
		len = 0;
	}

	// Remove any possible leftover <input> (those are wrapped in a div)
	$('c div').remove();

	// Clear possible suggestions ?
	// $('#suggestions').empty();

	// Determine the cursor position by the provided x coordinate (used font is 7.19 px per character (monospaced font))
	var pos = Math.max(0, Math.round(x / getFontMultiplier()));

	// Create the input with a wrapping div, set the text as the value, and append it to the column and focus on it.
	// Also add various attributes to disable native autocomplete, autocorrect, autocapitlization and spellchecking.
	var div = $('<div><input autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"></div>');
	var input = div.find('input');
	input.val(getColumnTextBasedOnElements(column));
	column.append(div);

	// TODO define different types depending on the DB being created (PostgreSQL, MySQL, MS-SQL, Generic)
	var sqlTypes = ['bigint','bigserial','bit','bool','boolean','box','bytea','char','cidr','circle','date','decimal', 'int4range', 'int8range', 'numrange', 'tsrange', 'tstzrange', 'daterange', 'float4','float8','inet','int','int2','int4','int8','integer','interval','json','jsonb','line','lseg','macaddr','money','numeric','path','pg_lsn','point','polygon','real','serial','serial2','serial4','serial8','smallint','smallserial','text','time','timetz','timestamp','timestamptz','tsquery','tsvector','txid_snapshot','uuid','varbit','varchar','xml'];

	// TODO allow for default suggestions to be edited in a user's account. For now it's hardcoded
	var userSuggestions = [
    	'name',
    	'firstname',
    	'middlename',
    	'lastname',
    	'username',
    	'password',
    	'email',
    	'active',
    	'created',
    	'updated',
    	'lastlogin',
    	'order',
    	'title',
    	'description',
    	'current_timestamp',
    	'true',
    	'false'
    ];
    var columnNames = userSuggestions.concat(getAllColumnNamesPrefixedByTablename(column));

    // Set the cursor position. This effectively also focuses on the input.
	setCursorPosition(input, pos, len);

	// When the input looses focus, destroy it and it's wrapping div.
	input.blur(function(event) {
		var input = $(this);
		var value = $.trim(input.val());
		input.val(value);
		createColumnElementsFromHiddenInput(input);

		// If the first column's name is "id" or ends in "_id" then add the p attribute to the column
		if(input.closest('c').prev().is('h') && (value.split(" ")[0] == "id" || value.split(" ")[0].slice(-3) == "_id")) {
			input.closest('c').attr('p', '');
		}

		input.closest('div').remove();

		// Clear the suggestions as well (if any)
		$('#suggestions').empty();
	});

	// Init the value before key up variable with the current value.
	var valueBeforeKeyup = input.val();

	// When the input changes, determine the values of all the elements.
	input.on('input', function(event) {
		createColumnElementsFromHiddenInput($(this));
	})
	// When a key is going down on the input, check a few things.
	.on('keydown', function(e) {

		// Capture the current value first.
		valueBeforeKeyup = $(this).val();

		// Pressing escape when focused in an input removes the suggestion box, or if that isn't there it blurs the input.
		if(e.which == 27) {
			eds(e);
			// Check if suggestions are displayed.
			if($('#suggestions li').length > 0) {
				$('#suggestions').empty();
				return;
			}

			// Suggestions aren't displayed, so blur the input itself.
			$(this).blur();
			return;
		}

		// alt+del removes the column
		if(e.which == 46 && e.altKey) {
			eds(e);
			removeColumn($(e.target).closest("c"));
			return;
		}

		// If pressing the backspace and it's not a repeating keydown
		if(e.which == 8 && !e.originalEvent.repeat) {

			// If the column has no value, remove it and focus on the previous column
			if($(this).val() == "") {
				eds(e);
				var column = $(e.target).closest("c");
				if(column.prev('c').length) {
					focusOnColumn(column.prev('c'), getColumnTextBasedOnElements(column.prev('c')).length * getFontMultiplier());
				} else {
					focusOnHead(column.closest('ta').find('h'), column.closest('ta').find('h input').val().length * getFontMultiplier());
				}
				removeColumn(column, true);
				return;
			}
		}

		// TODO do the same with del as with backspace

		// If it's the up or down key, prevent the default otherwise the cursor normally moves to the start or the end of the input field
		if(e.which == 40 || e.which == 38) {
			eds(e);

			// If the suggestion box is visible, then change the active selection
			if($('#suggestions li').length) {
				if(e.which == 38 && $('#suggestions li.active').prev('li').length) {
					$('#suggestions li.active').removeClass('active').prev('li').addClass('active');
				} else if(e.which == 40 && $('#suggestions li.active').next('li').length) {
					$('#suggestions li.active').removeClass('active').next('li').addClass('active');
				}

				// Scroll up until the active selection is visible
				while($('#suggestions li.active').offset().top < $('#suggestions').offset().top) {
					$('#suggestions').scrollTop($('#suggestions').scrollTop()-29);
				}

				// Scroll down until the active selection is visible
				while($('#suggestions li.active').offset().top > $('#suggestions').offset().top + (9*29)) {
					$('#suggestions').scrollTop($('#suggestions').scrollTop()+29);
				}

				return;
			}
		}

		// Get a reference to the column, the current cursor position and X coordinate
		var column = $(this).closest('c');
		var cursorPos = $(this).getCursorPosition();
		var cursorX = cursorPos * getFontMultiplier();

		// If the user presses arrow-down and there is another row below it, then move the cursor to that row
		if(e.which == 40 && column.next('c').length) {
			// if the alt key is pressed, move the current column down
			if(e.altKey) {
				column.next().after(column);
				redraw();
				focusOnColumn(column, cursorX);
			} else {
				focusOnColumn(column.next(), cursorPos*getFontMultiplier());
			}
		}

		// If the user presses arrow-up and there is another row above it, then move the cursor to that row
		if(e.which == 38 && column.prev().length) {

			// If the previous element is the <h> element, put focus on the header
			if(column.prev().is('h')) {
				focusOnHead(column.prev(),(cursorPos*getFontMultiplier())+30, 0);
			}
			// if the alt key is pressed, move the current column down
			else if(e.altKey) {
				column.prev().before(column);
				redraw();
				focusOnColumn(column, cursorX);
			// Otherwise move focus to the column above it.
			} else {
				focusOnColumn(column.prev(), cursorPos*getFontMultiplier());
			}
		}

		if(e.which == 9 || e.which == 13) {
			eds(e);
			if($('#suggestions li.active').length) {
				insertSuggestion($(this));
				return;
			} else if (e.which == 13) {
				addNewColumnBelow(column);
			}
		}
	})
	.on('keyup', function(e) {

		var value = $(this).val();

		// backspace = 8, 46 = del, 36 = home, 35 = end
		if(e.which == 8 || e.which == 46 || e.which == 36 || e.which == 35) {
			$('#suggestions').empty();
		}

		// ctrl = 17
		if(e.which != 17 && valueBeforeKeyup == value && !(e.which == 32 && e.ctrlKey)) {
			return;
		}

		var s = $('#suggestions');
		s.empty();

		var cursorPosition = $(this).getCursorPosition();
		var valueUpToCursor = value.substring(0, cursorPosition);
		var spaceCount = (valueUpToCursor.split(/[ \(]{1}/).length - 1);
		var cursorWord = value.split(/[ \(]{1}/)[spaceCount];

		if(spaceCount >= 2)
			return;

		var options = {
			shouldSort: true,
			includeMatches: true,
			threshold: 0.42,
			location: 0,
			distance: 25,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			keys: undefined
		};
		var fuse = new Fuse(spaceCount == 0 ? columnNames : sqlTypes, options);
		var result = fuse.search(cursorWord);

		for(var i = 0; i < result.length; i++) {
			if(result[i].matches.length > 0) {
				var text = result[i].matches[0].value;
				if(result.length > 1 || cursorWord != text) {
					var highlighted = generateHighlightedText(text, result[i].matches[0].indices);
					var elem = $("<li>" + highlighted + "</li>");
					s.append(elem);
				}
			}
		}

		s.find('li').first().addClass('active');

		var pos = $(this).offset();
		s.css({
			'top': pos.top+29,
			'left': pos.left-6 + (spaceCount > 0 ? (valueUpToCursor.split(" ")[0].length+1) * getFontMultiplier() : 0)
		});
	});

	var generateHighlightedText = function(text, matches) {
		var result = [];
		var pair = matches.shift();
		for (var i = 0; i < text.length; i++) {
			var char = text.charAt(i);
			if (pair && i == pair[0]) {
				result.push('<em>');
			}
			result.push(char);
			if (pair && i == pair[1]) {
				result.push('</em>');
				pair = matches.shift();
			}
		}
		return result.join('');
	};
}
function focusOnHead(head, x) {
	head.closest('h');

	// Determine the cursor position by the provided x coordinate (used font is 7.19 px per character (monospaced font))
	var pos = Math.max(0, Math.round(x / getFontMultiplier()));

	var input = head.find('input');
	setCursorPosition(input, pos);

	// When a key is going down on the input, check a few things.
	input.on('keydown', function(e) {

		// Pressing escape when focused in an input simply blurs the input and does nothing more (should update the menu though)
		if(e.which == 27) {
			$(this).blur();
			return;
		}

		// AlT + del removes the table
		if(e.which == 46 && e.altKey) {
			eds(e);
			removeTable($(this).closest("ta"));
			return;
		}

		// Enter in table head moves to first column
		if(e.which == 9 || e.which == 13) {
			eds(e);
			focusOnColumn($(this).closest('ta').find('c').first());
			return;
		}

		// If it's down key, move to the first column
		if(e.which == 40) {
			// prevent the default otherwise the cursor normally moves to the start or the end of the input field
			eds(e);

			// Get the current cursor position and X coordinate
			var cursorPos = $(this).getCursorPosition();
			var cursorX = (cursorPos * getFontMultiplier()) - 30; // compensate for the pk indent

			// Move to first column
			focusOnColumn($(this).closest('ta').find('c').first(), cursorX);
		}

		// When pressing tab, focus on first column
		if(e.which == 9) {
			eds(e);
			focusOnColumn($(this).closest('ta').find('c').first(), 0, 2);
		}

		// ALT + 0-9 changes table color
		if(e.which >= 48 && e.which <= 57 && e.altKey) {
			eds(e);
			color = e.which - 48;
			setTableColor($(this).closest('ta'));
			return;
		}
	});
}

$(function() {
	tm = $("#tm");
	nm = $('#nm');

	$(document).on('input keydown', 'h input', function(e) {
		checkSize($(this));
	});

	$('#view').on('input keydown', 'textarea', function(e) {
		var noteSize = getNoteSize($(e.target));
		$(e.target).closest('nt').css({'width': noteSize.width+'px', 'height': noteSize.height +'px'});
		$(e.target).scrollTop(0).scrollLeft(0);
	});

	$('h input').each(function(index, el) {
		checkSize($(this));
	});
});
$(function() {

	$('#addtable').click(function(event) {
		eds(event);
		addTable();
	});

	$('#addnote').click(function(event) {
		eds(event);
		addNote();
	});

	$(document).on('selectionChanged contentChanged', function(e) {
		$('#selectoff,#delete').toggleClass('enabled', $('#wrap .selected, #wrap [s]').length > 0);
		$('#tablecolor').toggleClass('enabled', $('#view ta[s]').length > 0);
	});

	$('#menu').on('click', '#selectoff.enabled', function(event) {
		eds(event);
		deselectAll();
	});

	$('#menu').on('click', '#delete.enabled', function(event) {
		eds(event);
		deleteSelectedElements();
	});

	$('#menu').on('click', '#tablecolor.enabled', function(event) {
		eds(event);
		var table = $('#view ta[s]').first();
		if(color++ >= 9) {
			color = 0;
		}
		setTableColor(table);
	});

	$('#save').click(function(event) {
		eds(event);
		saveDb();
	});

	$('#open').click(function(event) {
		eds(event);
		openDb();
	});

	new ClipboardJS('#sql', {
		text: function() {
			return generateSql();
		}
	}).on('success', function(e) {
		alert('SQL has been generated to your clipboard');
	});
});
$(function() {
	$(document).on('keydown', function(e) {

		// Just the alt by itself? Return.
		if(e.which == 18) {
			return;
		}

		// CTRL + A selects everything (except columns), but only if an input or textarea has no focus
		if(e.which == 65 && e.ctrlKey && !$(":focus").first().is("input,textarea")) {
			eds(e);
			selectAll();
		}

		// ALT + S
		if(e.which == 83 && e.ctrlKey) {
			eds(e);
			saveDb();
		}

		// ALT + O
		if(e.which == 79 && e.ctrlKey) {
			openDb();
		}

		// ALT + T
		if(e.which == 84 && e.altKey) {
			addTable(true);
		}

		// ALT + N
		if(e.which == 78 && e.altKey) {
			addNote(true);
		}

		// DEL
		if(e.which == 46 && !$(":focus").first().is("input")) {
			deleteSelectedElements();
		}

		// ALT + DEL on textarea
		if(e.which == 46 && e.altKey && $(":focus").first().is("textarea")) {
			$("textarea:focus").remove();
		}

		if(e.which == 27 && !$(":focus").first().is("input")) {
			deselectAll();
		}
	});
});
function generateSql() {

	var result = "";

	var addLine = function(line) {
		result += line + '\n';
	};

	// Basic table definitions
	$('#view ta').each(function(index, el) {
		var tablename = $(this).find('h input').val();
		var tn = tablename.split('.').pop();
		addLine('CREATE TABLE "' + tablename + '" (');
		var columns = [];
		var pks = [];
		var singleUnique = [];
		var multiUnique = [];
		$(this).find('c').each(function(index, el) {
			var column = "\t";
			var isPk = $(this).is('[p]');
			var isSingleUnique = $(this).is('[u]');
			var isMultiUnique = $(this).is('[uu]');
			var allowNull = $(this).is('[n]');
			var name = $.trim($(this).find('n').text());
			var type = $.trim($(this).find('t').text());
			var size = $.trim($(this).find('s').text());
			var defaultValue = $.trim($(this).find('d').text());

			if(name !== "" && type !== "") {

				if(isPk) {
					pks.push('"' + name + '"');
				}

				column += '"' + name + '" ' + type + size + (allowNull ? '' : ' NOT NULL') + (defaultValue !== "" ? ' DEFAULT ' + defaultValue : '');
				columns.push(column);
			}

			if(isSingleUnique) {
				singleUnique.push(name);
			}

			if(isMultiUnique) {
				multiUnique.push(name);
			}
		});

		if(pks.length) {
			columns.push('\tCONSTRAINT "pk_' + tablename.split('.').pop() + '" PRIMARY KEY (' + pks.join(', ') + ')');
		}

		addLine(columns.join(',\n'));
		addLine(');');

		if(singleUnique.length) {
			for(var u=0; u < singleUnique.length; u++) {
				addLine('ALTER TABLE "' + tablename + '" ADD CONSTRAINT "' + tn + '_unq_' + singleUnique[u] + '" UNIQUE ("' + singleUnique[u] + '");');
			}
		}

		if(multiUnique.length) {
			addLine('ALTER TABLE "' + tablename + '" ADD CONSTRAINT "' + tn + '_unq_' + multiUnique.join('_') + '" UNIQUE ("' + multiUnique.join('", "') + '");');
		}

		addLine('');
	});

	$('#view ta').each(function(index, el) {
		var tablename = $(this).find('h input').val();
		// Foreign key definitions
		$(this).find('c[fk]').each(function(index, el) {
			var t = $.trim($(this).find('n').text());
			var refColumn = $('#' + $(this).attr('fk'));
			var onDelete = "";
			var onUpdate = "";
			if($(this).is('[dc]')) onDelete = " ON DELETE CASCADE";
			if($(this).is('[dr]')) onDelete = " ON DELETE RESTRICT";
			if($(this).is('[dn]')) onDelete = " ON DELETE SET NULL";
			if($(this).is('[uc]')) onUpdate = " ON UPDATE CASCADE";
			if($(this).is('[ur]')) onUpdate = " ON UPDATE RESTRICT";
			if(refColumn.length && t !== "") {
				var refTableName = refColumn.closest('ta').find('h input').val();
				var refColumnName = $.trim(refColumn.find('n').text());
				addLine('ALTER TABLE "' + tablename + '" ADD CONSTRAINT "fk_' + t + '" FOREIGN KEY ("' + t + '") REFERENCES "' + refTableName + '"("' + refColumnName + '")' + onDelete + onUpdate + ';\n');
			}
		});
	});

	return result;
}


$(function() {

	if(window.location.href.indexOf('scrsh') == -1) {
		$('body').removeClass('initial');
	}

	// At application start do a redraw so the minimap etc is being updated.
	setTimeout(redraw, 100);
	$(document).trigger('contentChanged');

	// When the window is being resized, do a redraw.
	$(window).resize(function(event) {
		setWrapSize();
		redraw();
	});

	zoom = 1;
	setWrapSize();
});
